define('views/modules/calendar/nutrition/nutrient/nutrient-report',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/nutrition/nutrients',
    // views
    'views/modules/calendar/nutrition/nutrient/nutrient-component',
    // templates
    'text!templates/modules/calendar/nutrition/nutrient/nutrient-report.html',
    'text!templates/modules/calendar/nutrition/nutrient/nutrient-legend.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    NutrientService,
    // views
    VNutrientComponent,
    // templates
    TNutrientReport,
    TNutrientLegend
) {

    var VNutrientReport = Backbone.View.extend({
        template: TNutrientReport,
        nutrientLegendTemplate: TNutrientLegend,
        initialize: function(opt) {
            this.options = _.extend({}, {
                eatenFoodsOnly: true
            }, opt);

            this.view = {
                component: new VNutrientComponent({ inline: true, dark: false }),
            };

            this.listenTo(this.collection, 'change update reset', this.onUpdate);
        },

        render: function() {
            this.$el.empty()
                .append(this.template)
                .append(this.view.component.render().el);

            this.$el.append(Mustache.render(this.nutrientLegendTemplate, Mustache.getContext()));
            return this;
        },

        ////////////
        // events //
        ////////////
        onUpdate: function() {
            this.view.component.setNutrients(
                this.collection.getTotalNutrients({ isEaten: this.options.eatenFoodsOnly })
            );
        },

    });

    return VNutrientReport;

});

